import React from "react";
import "../assets/css/sections.css";
import { Calendar, Clock, CreditCard, MapPin, Shield, Truck } from "../components/Icons";

const FACTS = [
  {
    icon: <MapPin />,
    title: "Calgary and surrounding area",
    body: "Addresses are checked against our delivery zone at checkout, so you know before you pay.",
  },
  {
    icon: <Calendar />,
    title: "Delivered after the campaign closes",
    body: "Every order in a campaign is packed together once the group buy ends.",
  },
  {
    icon: <Clock />,
    title: "Within 7 business days",
    body: "Your share leaves the farm and reaches your door inside a week of the close date.",
  },
  {
    icon: <Truck />,
    title: "Flat $15 delivery",
    body: "One simple fee per order, added at checkout — no surge pricing, no surprises.",
  },
  {
    icon: <CreditCard />,
    title: "Secure card checkout",
    body: "Payments are processed by Stripe. We never see or store your card details.",
  },
  {
    icon: <Shield />,
    title: "Confirmed instantly",
    body: "You get confirmation the moment payment clears, and a tracking reference for your order.",
  },
];

const Delivery = () => (
  <section id="delivery" className="section section--surface delivery">
    <div className="container">
      <div className="delivery-grid">
        <div className="delivery-intro" data-reveal>
          <span className="eyebrow">Delivery</span>
          <h2>How your share reaches your door</h2>
          <p>
            Group buying only works if the logistics are predictable. Here is exactly what happens
            between placing your order and unpacking it at home.
          </p>
          <div className="delivery-zone">
            <span className="delivery-zone-icon" aria-hidden="true">
              <MapPin />
            </span>
            <div>
              <span className="delivery-zone-label">Current delivery zone</span>
              <strong>Calgary, Alberta</strong>
              <p>
                Your address is validated against the zone at checkout. We expand as new farms
                and neighbourhoods join — tell us where you are and we will let you know.
              </p>
            </div>
          </div>
        </div>

        <ul className="delivery-facts">
          {FACTS.map((fact, index) => (
            <li
              className="delivery-fact"
              key={fact.title}
              data-reveal
              style={{ "--reveal-delay": `${index * 60}ms` }}
            >
              <span className="delivery-fact-icon">{fact.icon}</span>
              <div>
                <h3>{fact.title}</h3>
                <p>{fact.body}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default Delivery;
